module.exports = __webpack_public_path__ + "static/img/next.d4e5ba04.svg";